export default __webpack_public_path__ + "static/media/img_baseCottonBunny_flowers_p.8b838415.jpg";